
// import React, { useEffect, useState, useContext } from "react";
// import {
//   Box,
//   Grid,
//   Paper,
//   Typography,
//   IconButton,
//   TextField,
//   Button
// } from "@mui/material";
// import { Refresh } from "@mui/icons-material";
// import { AuthenticationContext } from "../../../../../../../context/AuthenticationContext";
// import { InverterDetail } from "../../../../../../../api/Api";

// // ✅ Chart (Pie)
// import {
//   Chart as ChartJS,
//   ArcElement,
//   Tooltip,
//   Legend
// } from "chart.js";
// import { Pie } from "react-chartjs-2";

// ChartJS.register(ArcElement, Tooltip, Legend);

// export default function DashboardInverterTab4() {
//   const { LoggedInUserInfo } = useContext(AuthenticationContext);

//   const [logData, setLogData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [loading, setLoading] = useState(false);

//   const [credentials] = useState({
//     LOGIN_ID: localStorage.getItem("LoginID") || "",
//     LOC_CODE: localStorage.getItem("LCODE") || "",
//     PASS_KEY: localStorage.getItem("PASS_KEY"),
//     WEB_KEY: localStorage.getItem("WEB_KEY"),
//   });

//   // ✅ API Call
//   const fetchLogData = async () => {
//     setLoading(true);
//     try {
//       const res = await InverterDetail(credentials);
//       if (res?.data) {
//         setLogData(res.data);
//         setFilteredData(res.data);
//       }
//     } catch (err) {
//       console.log(err);
//     }
//     setLoading(false);
//   };

//   useEffect(() => {
//     fetchLogData();
//   }, []);

//   // ✅ Search
//   const handleSearch = () => {
//     const filtered = logData.filter((item) =>
//       Object.values(item)
//         .join(" ")
//         .toLowerCase()
//         .includes(searchQuery.toLowerCase())
//     );
//     setFilteredData(filtered);
//   };

//   // ✅ Dynamic Pie Chart Data
//   const chartData = {
//     labels: filteredData.map((item) => item.NAME),
//     datasets: [
//       {
//         label: "kW",
//         data: filteredData.map((item) => Number(item.KW)),
//         backgroundColor: [
//           "#4CAF50",
//           "#FF9800",
//           "#F44336",
//           "#2196F3",
//           "#9C27B0",
//           "#00BCD4",
//           "#FFC107"
//         ],
//         borderWidth: 1
//       }
//     ]
//   };

//   const cardStyle = {
//     p: 2,
//     borderRadius: 3,
//     boxShadow: 3,
//     height: "100%"
//   };

//   return (
//     <Box p={0} bgcolor="#f5f5f5">
//       <Grid container spacing={1}>

//         {/* ✅ LEFT SIDE TABLE */}
//         <Grid item xs={12} md={8}>
//           <Paper sx={cardStyle}>

//             {/* Header */}
//             <Box display="flex" justifyContent="space-between" mb={1}>
//               <Typography fontWeight="bold">
//                 Inverter Details
//               </Typography>

//               <Box display="flex" gap={1}>
//                 <TextField
//                   size="small"
//                   placeholder="Search..."
//                   value={searchQuery}
//                   onChange={(e) => setSearchQuery(e.target.value)}
//                 />
//                 <Button variant="contained" onClick={handleSearch}>
//                   Search
//                 </Button>
//                 <IconButton onClick={fetchLogData}>
//                   <Refresh />
//                 </IconButton>
//               </Box>
//             </Box>

//             {/* Table */}
//             <Box sx={{ overflow: "auto" }}>
//               <table style={{ width: "100%", borderCollapse: "collapse" }}>
//                 <thead>
//                   <tr style={{ background: "#eee" }}>
//                     <th>SN</th>
//                     <th>Name</th>
//                     <th>Make</th>
//                     <th>kW</th>
//                     <th>Status</th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {loading ? (
//                     <tr>
//                       <td colSpan="5">Loading...</td>
//                     </tr>
//                   ) : filteredData.length > 0 ? (
//                     filteredData.map((item, index) => (
//                       <tr key={index}>
//                         <td>{index + 1}</td>
//                         <td>{item.NAME}</td>
//                         <td>{item.MAKE}</td>
//                         <td>{item.KW}</td>
//                         <td
//                           style={{
//                             color:
//                               Number(item.KW) === 0 ? "red" : "green",
//                             fontWeight: "bold"
//                           }}
//                         >
//                           {Number(item.KW) === 0
//                             ? "Offline"
//                             : "Online"}
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan="5">No Data</td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </Box>

//           </Paper>
//         </Grid>

//         {/* ✅ RIGHT SIDE SMALL PIE CHART */}
//         <Grid item xs={12} md={4}>
//           <Paper sx={cardStyle}>
//             <Typography fontWeight="bold" mb={1}>
//               Total Instant Power [KW]
//             </Typography>

//             {filteredData.length > 0 ? (
//               <Box display="flex" justifyContent="center" alignItems="center">
//                 <Box sx={{ width: 250, height: 250 }}>
//                   <Pie
//                     data={chartData}
//                     options={{
//                       maintainAspectRatio: false
//                     }}
//                   />
//                 </Box>
//               </Box>
//             ) : (
//               <Typography>No Chart Data</Typography>
//             )}
//           </Paper>
//         </Grid>

//       </Grid>             
//     </Box>
//   );
// }


// 2.

import React, { useEffect, useState, useContext } from "react";
import {
  Box,
  Grid,
  Paper,
  Typography,
  IconButton,
  TextField,
  Button
} from "@mui/material";
import { Refresh } from "@mui/icons-material";
import { AuthenticationContext } from "../../../../../../../context/AuthenticationContext";
import {  MainSliderApi } from "../../../../../../../api/Api";

// ✅ Chart (Pie)
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from "chart.js";
import { Pie } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

export default function DashboardInverterTab4() {
  const { LoggedInUserInfo } = useContext(AuthenticationContext);

  const [logData, setLogData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);

  const [credentials] = useState({
    USER_ID: localStorage.getItem("LoginID"),
    PLANT_code: localStorage.getItem("LCODE"),
    pass_key: localStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
    Stype: "",
  });

  // ✅ API Call
  const fetchLogData = async () => {
    setLoading(true);
    try {
      const res = await MainSliderApi(credentials);
      if (res?.data) {
        setLogData(res.data);
        setFilteredData(res.data);
      }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchLogData();
  }, []);

  // ✅ Search
  const handleSearch = () => {
    const filtered = logData.filter((item) =>
      Object.values(item)
        .join(" ")
        .toLowerCase()
        .includes(searchQuery.toLowerCase())
    );
    setFilteredData(filtered);
  };

  // ✅ Dynamic Pie Chart Data
  const chartData = {
    labels: filteredData.map((item) => item.NAME),
    datasets: [
      {
        label: "kW",
        data: filteredData.map((item) => Number(item.KW)),
        backgroundColor: [
          "#4CAF50",
          "#FF9800",
          "#F44336",
          "#2196F3",
          "#9C27B0",
          "#00BCD4",
          "#FFC107"
        ],
        borderWidth: 1
      }
    ]
  };

  const cardStyle = {
    p: 2,
    borderRadius: 3,
    boxShadow: 3,
    height: "100%"
  };

  return (
    // <>
    //   {filteredData.length > 0 ? (
    //     <Box
    //       display="flex"
    //       justifyContent="center"
    //       alignItems="center"
    //       sx={{
    //         width: "100%",
    //         height: 180,
    //       }}
    //     >
    //       <Box
    //         sx={{
    //           width: 180,
    //           height: 180,
    //         }}
    //       >
    //         <Pie
    //           data={chartData}
    //           options={{
    //             responsive: true,
    //             maintainAspectRatio: false,
    //             plugins: {
    //               legend: {
    //                 position: "bottom",
    //               },
    //             },
    //           }}
    //         />
    //       </Box>
    //     </Box>
    //   ) : (
    //     <Typography align="center">
    //       No Chart Data
    //     </Typography>
    //   )}
    // </>

    <>
  {filteredData.length > 0 ? (
    <Box
      sx={{
        width: "100%",
        height: 150,
      }}
    >
      <Pie
        data={chartData} 
        options={{
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false, // Hide labels
            },
            tooltip: {
              enabled: true,
            },
          },
        }}
      />
    </Box>
  ) : (
    <Typography align="center">
      No Chart Data 
    </Typography> 
  )}
</>
  );
}
